import {
  GET_PROJECT_STATUS_REQUEST,
  GET_PROJECT_STATUS_SUCCESS,
  GET_PROJECT_STATUS_FAIL,
  GET_SINGLE_PROJECT_STATUS_REQUEST,
  GET_SINGLE_PROJECT_STATUS_SUCCESS,
  GET_SINGLE_PROJECT_STATUS_FAIL,
  CREATE_PROJECT_STATUS_REQUEST,
  CREATE_PROJECT_STATUS_SUCCESS,
  CREATE_PROJECT_STATUS_FAIL,
  UPDATE_PROJECT_STATUS_REQUEST,
  UPDATE_PROJECT_STATUS_SUCCESS,
  UPDATE_PROJECT_STATUS_FAIL,
  DELETE_PROJECT_STATUS_REQUEST,
  DELETE_PROJECT_STATUS_SUCCESS,
  DELETE_PROJECT_STATUS_FAIL,
  CLEAR_PROJECT_STATUS_RECORD,
} from "../constant/ProjectStatusConstant";

const initialState = {
  loading: false,
  action: "Project_Status",
  result: [],
  success: false,
  singledata: [],
  message: "",
  error: "",
};

const ProjectStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROJECT_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_PROJECT_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload.data.list,
        message: action.message,
      };

    case GET_PROJECT_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        message: action.message,
      };

    case GET_SINGLE_PROJECT_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_SINGLE_PROJECT_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        singledata: action.payload.data,
        message: action.message,
      };
    case GET_SINGLE_PROJECT_STATUS_FAIL:
      return {
        loading: false,
        error: action.error,
        message: action.message,
      };

    case CREATE_PROJECT_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CREATE_PROJECT_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        result: state.result.filter((items) =>
          items.id === action.payload.id
            ? Object.assign({}, items, action.payload)
            : items
        ),
        message: action.message,
      };

    case CREATE_PROJECT_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        message: action.message,
      };

    case UPDATE_PROJECT_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_PROJECT_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        result: state.result.map((items) =>
          items.id === action.payload.id
            ? Object.assign({}, items, action.payload)
            : items
        ),
        message: action.message,
      };
    case UPDATE_PROJECT_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        message: action.message,
        error: action.error,
      };
    case DELETE_PROJECT_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DELETE_PROJECT_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        result: state.result.filter((item) => item.id !== action.payload.id),
        message: action.message,
      };
    case DELETE_PROJECT_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        message: action.message,
      };

    case CLEAR_PROJECT_STATUS_RECORD:
      return {
        ...state,
        loading: false,
        success: false,
        result: [],
        singledata: [],
        message: action.message,
      };
    default:
      return state;
  }
};

export default ProjectStatusReducer;
